import React from 'react';
import { BaseMultiSelect } from 'shared/inputs';
import useDataLoadingState from 'shared/../hooks/useDataLoadingState';
import { requestStatuses } from 'shared/../constants/store';
import { getCounties } from 'src/fetch/locations';

const CountiesMultiSelect = ({ stateId, ...props }) => {
  const { status, data } = useDataLoadingState(() => getCounties({ state: stateId }));
  const options = data ? data.map(({ id, name }) => ({ countyId: id, countyName: name })) : [];
  return (
    <BaseMultiSelect
      {...props}
      loading={status === requestStatuses.INIT || status === requestStatuses.PENDING}
      data={options}
      textField="countyName"
      dataItemKey="countyId"
      autoClose={false}
    />
  );
};

export default CountiesMultiSelect;
